import { BEMPlugin } from "@/MarketSearch/plugins/BEM.plugin";
import TRANSLATION_GERMAN from "@/MarketSearch/translations/de.json";
import {Translation} from "@/MarketSearch/plugins/Translation.plugin";
import { VueInterface } from "@/shared/interfaces/VueInterface";
import {store} from '@/MarketSearch/store';
import App from './app.vue'
import { OpeningHours } from "@/MarketSearch/plugins/OpeningHours.plugin";
import { Distance } from "@/MarketSearch/plugins/Distance.plugin";
import { Responsive } from "@/MarketSearch/plugins/Responsive.plugin";
import googleMapsApiKey from '@/shared/googleMapsAPIKey';

store.dispatch('setMapsAPIKey', googleMapsApiKey);

export const initialize = (Vue: VueInterface) => {
    Vue.use(Translation, TRANSLATION_GERMAN);
    Vue.use(BEMPlugin);
    Vue.use(Distance);
    Vue.use(OpeningHours);
    Vue.use(Responsive);
    
    document.querySelectorAll('.offer-selection-field').forEach((el: Element) => {
        store.dispatch('setConfig', (el as HTMLElement).dataset);
        new Vue({
            el,
            store,
            data: (el as HTMLElement).dataset,
            render: h => h(App)
        })
    })
};
